import commitSha from './commitSha.txt';

export const COMMIT_SHA = commitSha.trim();
